<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xqehbd/tc-custom/9781460313527.jpg?1731056038129" alt="This image is the cover for the book Deputy Gets Her Man, Men of the West"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deputy Gets Her Man, Men of the West
      </h1>
      <p class="bookDescription body article font2">
        <b>A female cop investigates a reclusive rancher and falls in love with him in this western romance from a <i>USA Today</i>–bestselling author.</b><br/><br/>Everyone knew that Tyler Pickens was the grumpiest, most reclusive rancher in town. But Deputy Sheriff Rosalinda Lightfoot hadn’t realized he was also the sexiest. When her arson investigation brought her face-to-face with Ty, she couldn’t deny the flutter his green-eyed gaze ignited. But she was wary of men with secrets—and Tyler had plenty.<br/><br/>Tyler couldn’t deny his instant connection to Rosalinda or the feelings he’d thought long dead. But his betrayed heart wasn’t so easy to heal. As the excitement heated up and secrets came to light, could Rosalinda and Tyler forget their pasts and make their own future?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stella Bagwell
      </h2>
      
      <p class="authorDescription body article">The author of over seventy-five titles for Harlequin, Stella Bagwell writes about familes, the West, strong, silent men of honor and the women who love them. She credits her loyal readers and hopes her stories have brightened their lives in some small way. A cowgirl through and through, she recently learned how to rope a steer. Her days begin and end helping her husband on their south Texas ranch. In between she works on her next tale of love. Contact her at stellabagwell@gmail.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c10a1f2